import { inject } from '@angular/core';
import { Observable, finalize, of, shareReplay, tap } from 'rxjs';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { ApiResponse } from '../models/api.model';
import {
  ConfiguracionSistema,
  ConfiguracionSistemaRequest,
} from '../models/configuracion-sistema.model';
import { DEFAULT_SYSTEM_CONFIG } from '../models/configuracion-sistema.model';
import { ConfiguracionSistemaService } from '../services/configuracion-sistema.service';

interface SystemConfigState {
  configuracion: ConfiguracionSistema | null;
  loading: boolean;
  error: string;
}

export const SystemConfigStore = signalStore(
  { providedIn: 'root' },
  withState<SystemConfigState>({ configuracion: null, loading: false, error: '' }),
  withMethods((store, service = inject(ConfiguracionSistemaService)) => {
    let initialized = false;
    let inFlight: Observable<ApiResponse<ConfiguracionSistema>> | null = null;

    return {
      load(): Observable<ApiResponse<ConfiguracionSistema>> {
        if (initialized && store.configuracion()) {
          return of({
            success: true,
            data: store.configuracion(),
          } as ApiResponse<ConfiguracionSistema>);
        }
        if (inFlight) return inFlight;
        initialized = true;
        patchState(store, { loading: true, error: '' });
        inFlight = service.get().pipe(
          tap((response) => {
            if (response.data) patchState(store, { configuracion: response.data, error: '' });
          }),
          finalize(() => {
            patchState(store, { loading: false });
            inFlight = null;
          }),
          shareReplay(1),
        );
        return inFlight;
      },
      save(
        configuracion: ConfiguracionSistemaRequest,
      ): Observable<ApiResponse<ConfiguracionSistema>> {
        patchState(store, { loading: true, error: '' });
        return service.update(configuracion).pipe(
          tap((response) => {
            if (response.data) patchState(store, { configuracion: response.data });
          }),
          finalize(() => patchState(store, { loading: false })),
        );
      },
      defaults(): ConfiguracionSistemaRequest {
        return { ...DEFAULT_SYSTEM_CONFIG };
      },
    };
  }),
);
